import { SettingsComponent } from './settings/settings.component';
import { ActivitiesModule } from './activities/activities.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { SharedModule } from '@tech-utils/shared.module';
import { MainRoutingModule } from './main-routing.module';
import { MenumainComponent } from './menumain/menumain.component';
import { UpnavbarComponent } from './upnavbar/upnavbar.component';
import { DocumentationmanagerComponent } from './documentationmanager/documentationmanager.component';
import { ProfilePortfolioComponent } from './profileportfolio/profileportfolio.component';
import { PortfolioDataComponent } from './profileportfolio/portfolio-data/portfolio-data.component';
import { ChartPrincipalComponent } from './profileportfolio/chart-principal/chart-principal.component';
import { PortfolioSumaryComponent } from './profileportfolio/portfolio-data/portfolio-sumary/portfolio-sumary.component';
import { PortfolioPositionsComponent } from './profileportfolio/portfolio-data/portfolio-positions/portfolio-positions.component';
import { PortfolioCompositionsComponent } from './profileportfolio/portfolio-data/portfolio-compositions/portfolio-compositions.component';
import { PortfolioTradesComponent } from './profileportfolio/portfolio-data/portfolio-trades/portfolio-trades.component';
import { OpenpdfComponent } from './openpdf/openpdf.component';
import { FootermainComponent } from './footermain/footermain.component';
import { NgxMaskModule } from 'ngx-mask';
import { DatagridPositionsComponent } from './profileportfolio/portfolio-data/portfolio-positions/datagrid-positions/datagrid-positions.component';
import { DatagridPositionsAssetsComponent } from './profileportfolio/portfolio-data/portfolio-positions/datagrid-positions-assets/datagrid-positions-assets.component';
import { DatagridTradesComponent } from './profileportfolio/portfolio-data/portfolio-trades/datagrid-trades/datagrid-trades.component';
import { DocProviderComponent } from './documentationmanager/doc-provider/doc-provider.component';
import { DocSignedComponent } from './documentationmanager/doc-signed/doc-signed.component';
import { DocReportsComponent } from './documentationmanager/doc-reports/doc-reports.component';
import { CompletedataComponent } from './completedata/completedata.component';
import { InitialcontributionComponent } from './initialcontribution/initialcontribution.component';
import { SimulationDataInitComponent } from './initialcontribution/simulation-data-init/simulation-data-init.component';
import { SimulationInitDistributionComponent } from './initialcontribution/simulation-data-init/simulation-init-distribution/simulation-init-distribution.component';
import { SimulationInitFeesComponent } from './initialcontribution/simulation-data-init/simulation-init-fees/simulation-init-fees.component';
import { SimulationInitBarsComponent } from './initialcontribution/simulation-data-init/simulation-init-distribution/simulation-init-bars/simulation-init-bars.component';
import { SimulationInitModelportfolioComponent } from './initialcontribution/simulation-data-init/simulation-init-distribution/simulation-init-modelportfolio/simulation-init-modelportfolio.component';

import { RiskprofileComponent } from './questionnaire/riskprofile/riskprofile.component';
import { StepComponent } from './step/step.component';
import { RoadmapComponent } from './step/roadmap/roadmap.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ModalriskwarningComponent } from './initialcontribution/modalriskwarning/modalriskwarning.component';
import { TechTableInfoModalComponent } from './../../shared/tech-table-info-modal/tech-table-info-modal.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { ModalCashinComponent } from './profileportfolio/modal-cashin/modal-cashin.component';

import { DatacollectionComponent } from './datacollection/datacollection.component';

import { ModalriskwarningFundingComponent } from './datacollection/funding/fundingdistribution/modalriskwarning/modalriskwarning.component';
import { MainsettingsComponent } from './mainsettings/mainsettings.component';
import { SignComponent } from './sign/sign.component';
import { ThemeSelectorComponent } from '../../shared/theme-selector/theme-selector.component';
import { PortfolioLiabilitiesComponent } from './profileportfolio/portfolio-data/portfolio-liabilities/portfolio-liabilities.component';
import { ChatwhatssapComponent } from './chatwhatssap/chatwhatssap.component';
import { EvaChatComponent } from './eva-chat/eva-chat.component';

@NgModule({
  declarations: [
    MainComponent,
    MenumainComponent,
    UpnavbarComponent,
    DocumentationComponent,
    DocumentationmanagerComponent,
    ProfilePortfolioComponent,
    ChartPrincipalComponent,
    PortfolioDataComponent,
    PortfolioSumaryComponent,
    PortfolioPositionsComponent,
    PortfolioCompositionsComponent,
    PortfolioTradesComponent,
    OpenpdfComponent,
    FootermainComponent,
    DatagridPositionsComponent,
    DatagridPositionsAssetsComponent,
    DatagridTradesComponent,
    DocProviderComponent,
    DocSignedComponent,
    DocReportsComponent,
    RiskprofileComponent,
    TechTableInfoModalComponent,
    CompletedataComponent,
    InitialcontributionComponent,
    SimulationDataInitComponent,
    SimulationInitDistributionComponent,
    SimulationInitFeesComponent,
    SimulationInitBarsComponent,
    SimulationInitModelportfolioComponent,
    StepComponent,
    RoadmapComponent,
    ModalriskwarningComponent,
    ModalriskwarningFundingComponent,
    ModalCashinComponent,
    SettingsComponent,
    DatacollectionComponent,
    ThemeSelectorComponent,
    MainsettingsComponent,
    SignComponent,
    PortfolioLiabilitiesComponent,
    ChatwhatssapComponent,
    EvaChatComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MainRoutingModule,
    ClipboardModule,
    ActivitiesModule,
    NgxMaskModule,
  ],
  exports: [],
})
export class MainModule {}
